import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "table-delete",
  "use": "table-delete-usage",
  "viewBox": "0 0 14 18",
  "content": "<symbol viewBox=\"0 0 14 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"table-delete\">\n<path d=\"M1 16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4H1V16ZM14 1H10.5L9.5 0H4.5L3.5 1H0V3H14V1Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol